/**
 * Приоритет холодного старта: код из ссылки (`startapp`) важнее сохранённого
 * в localStorage — человек только что перешёл по ссылке, и это, скорее всего,
 * другая комната, чем та, что была открыта в прошлый раз.
 */
export function resolveRoomCode(startParam: string | undefined, stored: string | null): string | null {
  return startParam || stored || null;
}
